import { useEffect, useState } from "react";
import { useChatStore } from "../../stores/ChatStore";
import useAccessToken from "../../hooks/AccessToken";
import { useIntl } from "react-intl";
import { KTSVG, toAbsoluteUrl } from "../../_metronic/helpers";
import useSWR, { mutate } from "swr";
import { DateRangePicker } from 'rsuite'
import 'moment/locale/id';
import useUser from "../../hooks/User";
import { useSettingsStore } from "../../stores/SettingsStore";
import axios from "axios";
import { Pipeline } from "../../interfaces/Pipeline";
import { currencyFormatter, formatSecondsToTime, getDateRangeDuration, getDateSummary } from "../../functions/general";
import { Meeting } from "../../interfaces/Meeting";
import moment from "moment";
import { Tooltip } from 'react-tippy';
import { OverlayTrigger, Tooltip as TooltipBs } from "react-bootstrap";
import { usePipelineStore } from "../../stores/PipelineStore";
import { ChatDetailPipeline } from "./Detail/ChatDetailPipeline";
import { ChatDetailMeeting } from "./Detail/ChatDetailMeeting";
import { useMeetingStore } from "../../stores/MeetingsStore";
import { defaultScope } from "../DataTable/UserScopeModal";
import { ChatAgent, ChatMerchant } from "../../interfaces/Chat/Chat";
import usePredefinedRanges from "../../hooks/PredefinedRanges";
import useCalendarLocale from "../../hooks/CalendarLocale";
import { isToday, parseISO } from "date-fns";
import useCheckIsMobile from "../../hooks/useCheckIsMobile";
import { ChatDetailSession } from "./Detail/ChatDetailSession";
import { Merchant } from "../../interfaces/Merchant";
import { useMerchantStore } from "../../stores/MerchantStore";
import { ChatDetailMerchant } from "./Detail/ChatDetailMerchant";

interface Props {
}

const DetailContactChat = ({ }: Props) => {
    const API_URL = process.env.REACT_APP_API_URL
    const { phoneNumber, startDateSession, setStartDateSession, endDateSession, setEndDateSession, listChatRooms, isOpenDetailContact, setIsOpenDetailContact, selectedChatPhone } = useChatStore()
    const predefinedRanges = usePredefinedRanges();
    const calendarLocale = useCalendarLocale();
    const token = useAccessToken();
    const intl = useIntl();
    const user = useUser()
    const { isMobile } = useCheckIsMobile()
    const { multiPipelines, setSelectMultiPipeline } = usePipelineStore()
    const { multiMeetings, setSelectMultiMeeting } = useMeetingStore()
    const { multiMerchants, setSelectMultiMerchant } = useMerchantStore()
    const { settings } = useSettingsStore()
    const [listPipeliens, setListPipelines] = useState<Pipeline[]>([])
    const [listMeetings, setListMeetings] = useState<Meeting[]>([])
    const [listMerchants, setListMerchants] = useState<Merchant[]>([])
    const [listSessionHistories, setListSessionHistories] = useState<ChatAgent[]>([])

    const [originalListPipelines, setOriginalListPipelines] = useState<Pipeline[]>([]);
    const [originalListMeetings, setOriginalListMeetings] = useState<Meeting[]>([]);
    const [originalListMerchants, setOriginalListMerchants] = useState<Merchant[]>([]);
    const [originalListSessionHistories, setOriginalListSessionHistories] = useState<ChatAgent[]>([]);

    const [searchPipeline, setSearchPipeline] = useState("");
    const [searchMeeting, setSearchMeeting] = useState("");
    const [searchMerchant, setSearchMerchant] = useState("");
    const [searchSessionHistory, setSearchSessionHistory] = useState("");

    const [showDetailPipeline, setShowDetailPipeline] = useState<boolean>(false);
    const [showDetailMeeting, setShowDetailMeeting] = useState<boolean>(false);
    const [showDetailSession, setShowDetailSession] = useState<boolean>(false);
    const [showDetailMerchant, setShowDetailMerchant] = useState<boolean>(false);

    const [pipeline, setPipeline] = useState<Pipeline>();
    const [meeting, setMeeting] = useState<Meeting>();
    const [merchant, setMerchant] = useState<Merchant>();
    const [sessionHistory, setSessionHistory] = useState<ChatAgent>();
    const recentChat = listChatRooms[phoneNumber]

    let name = ''
    if (recentChat) {
        if (recentChat?.roomPhone !== user.data.phone) {
            if (recentChat?.roomName) name = recentChat?.roomName
            else name = recentChat?.roomPhone
        } else {
            name = user.data.name + ' (You)'
        }
    }

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data).catch(error => {
        throw error.response ? error.response.data : error;
    })

    const getPipelineURL = () => {
        if (user.data.is_superadmin) {
            return `${API_URL}leads?scope=all&merchant_phone=${phoneNumber.split('-')[0]}`
        } else if (user.data.permission_pipeline_read !== 'NONE') {
            return `${API_URL}leads?scope=${defaultScope(user.data.permission_pipeline_read)}&user_id=${user.data.id}&merchant_phone=${phoneNumber.split('-')[0]}`
        } else return null
    }

    const getMeetingURL = () => {
        if (user.data.is_superadmin) {
            return `${API_URL}meetings?scope=all&merchant_phone=${phoneNumber.split('-')[0]}`
        } else if (user.data.permission_meeting_read !== 'NONE') {
            return `${API_URL}meetings?scope=${defaultScope(user.data.permission_meeting_read)}&user_id=${user.data.id}&merchant_phone=${phoneNumber.split('-')[0]}`
        } else return null
    }

    const getMerchantURL = () => {
        if (user.data.is_superadmin) {
            return `${API_URL}merchants?scope=all&phone=${phoneNumber.split('-')[0]}`
        } else if (user.data.permission_merchant_read !== 'NONE') {
            return `${API_URL}merchants?scope=${defaultScope(user.data.permission_merchant_read)}&user_id=${user.data.id}&phone=${phoneNumber.split('-')[0]}`
        } else return null
    }

    const getSessionHistoryURL = () => {
        if (settings.chat_version === 'v2') {
            const queryParams = [
                ...selectedChatPhone.map(phone => `phonesId[]=${encodeURIComponent(phone.id)}`),
                `customerPhone=${encodeURIComponent(phoneNumber.split('-')[0])}`,
                `dateStartFrom=${encodeURIComponent(moment(startDateSession).toISOString())}`,
                `dateStartTo=${encodeURIComponent(isToday(parseISO(moment(endDateSession).toISOString())) ? moment(endDateSession).add(1, 'days').toISOString() : moment(endDateSession).toISOString())}`
            ].join('&');

            if (user.data.is_superadmin) return `${API_URL}chat-agent/admin/sessions?${queryParams}`
            else return `${API_URL}chat-agent/agent/sessions?${queryParams}`
        } else return null
    }

    const { data: dataPipelines = [], isValidating: isValidatingDataPipelines } = useSWR(isOpenDetailContact ? getPipelineURL() : null, fetcher)
    const { data: dataMeetings = [], isValidating: isValidatingDataMeetings } = useSWR(isOpenDetailContact ? getMeetingURL() : null, fetcher)
    const { data: dataMerchants = [], isValidating: isValidatingDataMerchants } = useSWR(isOpenDetailContact ? getMerchantURL() : null, fetcher)
    const { data: dataSessionHistories = [], isValidating: isValidatingDataSessionHistories } = useSWR(isOpenDetailContact ? getSessionHistoryURL() : null, fetcher)

    const returnStatus = (meeting: Meeting) => {
        if (meeting.status === intl.formatMessage({ id: 'MEETING.STATUS.SCHEDULED' })) {
            return <span className="badge badge-info" >{intl.formatMessage({ id: 'MEETING.STATUS.SCHEDULED' })}</span>
        } else if (meeting.status === intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' })) {
            return <span className="badge badge-success" >{intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' })}</span>
        } else if (meeting.status === intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' })) {
            return <span className="badge badge-warning" >{intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' })}</span>
        } else {
            return (
                <>
                    {
                        (meeting.meetingStatusNote)?.includes("sistem") ?
                            <Tooltip
                                title={`${intl.formatMessage({ id: 'TOOLTIP.AUTO_CANCEL_SYSTEM' })}`}
                                theme="light"
                                arrow={true}
                                className="btn btn-icon btn-flush w-auto"
                                style={{ cursor: "default", display: "flex" }}
                            >
                                <i className='fas fa-info-circle me-2 fs-7'></i>
                                <span className="badge badge-danger" >{intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' })}</span>
                            </Tooltip>
                            :
                            <span className="badge badge-danger" >{intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' })}</span>
                    }
                </>
            )
        }
    }

    const handleSearchPipeline = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLowerCase();
        setSearchPipeline(value);

        const filtered = originalListPipelines.filter(
            (item) =>
                String(item.lead_age)?.toLowerCase().includes(value) ||
                String(item.nominal)?.toLowerCase().includes(value) ||
                item.merchant_name?.toLowerCase().includes(value) ||
                item.owner_name?.toLowerCase().includes(value) ||
                item.lead_template_name?.toLowerCase().includes(value)
        );

        setListPipelines(filtered);
    };

    const handleSearchMeeting = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLowerCase();
        setSearchMeeting(value);

        const filtered = originalListMeetings.filter(
            (item) =>
                item.status?.toLowerCase().includes(value) ||
                item.owner_name?.toLowerCase().includes(value) ||
                item.date_meet?.toLowerCase().includes(value)
        );

        setListMeetings(filtered);
    };

    const handleSearchMerchant = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLowerCase();
        setSearchMerchant(value);

        const filtered = originalListMerchants.filter(
            (item) =>
                item.ownerName?.toLowerCase().includes(value) ||
                item.name?.toLowerCase().includes(value) ||
                item.phone?.toLowerCase().includes(value) ||
                item.email?.toLowerCase().includes(value) ||
                item.cityName?.toLowerCase().includes(value)
        );

        setListMerchants(filtered);
    };

    const handleSearchSession = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.toLowerCase();
        setSearchSessionHistory(value);

        const filtered = originalListSessionHistories.filter(
            (item) =>
                item.state.toLowerCase().includes(value) ||
                item.handler.name.toLowerCase().includes(value) ||
                moment(item.lastActivity.date).utc(true).format('DD MMMM YYYY HH:mm').toLowerCase().includes(value)
        );

        setListSessionHistories(filtered);
    };

    const handleClickDetailPipeline = (data: Pipeline) => {
        const dataTemplate = multiPipelines.find(item => item.id === data.lead_template_id)
        setSelectMultiPipeline(dataTemplate!)
        setPipeline(data)
        setShowDetailPipeline(true)
    }

    const handleClickDetailMeeting = (data: Meeting) => {
        const dataTemplate = multiMeetings.find(item => item.id === data.meetingTemplateId)
        setSelectMultiMeeting(dataTemplate!)
        setMeeting(data)
        setShowDetailMeeting(true)
    }

    const handleClickDetailSession = (data: ChatAgent) => {
        setSessionHistory(data)
        setShowDetailSession(true)
    }

    const handleClickDetailMerchant = (data: Merchant) => {
        const dataTemplate = multiMerchants.find(item => item.id === data.merchantTemplateId)
        setSelectMultiMerchant(dataTemplate!)
        setMerchant(data)
        setShowDetailMerchant(true)
    }

    const returnHandlerSession = (data: ChatAgent) => {
        const { started, ended } = data;

        if (!ended) return started.name;

        return started.name === ended.name
            ? started.name
            : `${started.name} - ${ended.name}`;
    };


    useEffect(() => {
        if (!isValidatingDataPipelines && dataPipelines.length > 0) {
            const pipelienTemps = dataPipelines.map((pipeline: Pipeline) => ({
                ...pipeline,
                lead_age: getDateSummary(pipeline.lead_age),
                nominal: `${currencyFormatter(pipeline.nominal, user?.data?.companyCurrencyNeedRound, user?.data?.companyCurrency, { showPrefix: true })}`,
            }));

            setOriginalListPipelines(pipelienTemps)
            setListPipelines(pipelienTemps)

            if (pipeline) {
                const updatePipeline = pipelienTemps.find((item: Pipeline) => item.id === pipeline.id)
                setPipeline(updatePipeline)
            }
        }
    }, [dataPipelines])

    useEffect(() => {
        if (!isValidatingDataMeetings && dataMeetings.length > 0) {
            const meetingTemps = dataMeetings.map((meeting: Meeting) => ({
                ...meeting,
                status: meeting.status === "PLANNED" ? intl.formatMessage({ id: 'MEETING.STATUS.SCHEDULED' }) : meeting.status === "COMPLETED" ? intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' }) : meeting.status === "ONGOING" ? intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' }) : intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' }),
            }));

            setOriginalListMeetings(meetingTemps)
            setListMeetings(meetingTemps)

            if (meeting) {
                const updateMeeting = meetingTemps.find((item: Meeting) => item.id === meeting.id)
                setMeeting(updateMeeting)
            }
        }
    }, [dataMeetings])

    useEffect(() => {
        if (!isValidatingDataMerchants && dataMerchants.length > 0) {
            const merchantTemps = dataMerchants.map((merchant: Merchant) => ({
                ...merchant,
            }));

            setOriginalListMerchants(merchantTemps)
            setListMerchants(merchantTemps)

            if (merchant) {
                const updateMerchant = merchantTemps.find((item: Merchant) => item.id === merchant.id)
                setMerchant(updateMerchant)
            }
        }
    }, [dataMerchants])

    useEffect(() => {
        if (!isValidatingDataSessionHistories && dataSessionHistories.length > 0) {
            const sortedData = dataSessionHistories.sort((a: ChatAgent, b: ChatAgent) => {
                return new Date(b.started.date).getTime() - new Date(a.started.date).getTime();
            });
            setOriginalListSessionHistories(sortedData)
            setListSessionHistories(sortedData)

            if (sessionHistory) {
                const updateSessionHistory = sortedData.find((item: ChatAgent) => item.id === sessionHistory.id)
                setSessionHistory(updateSessionHistory)
            }
        }
    }, [dataSessionHistories])

    return (
        <div className="col-12 col-md-6 col-lg-6 col-xl-6" style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)", overflow: "auto", backgroundColor: "#f5f8fa" }}>
            {
                showDetailPipeline && settings.feature_pipeline ?
                    <ChatDetailPipeline dataPipeline={pipeline!} setShowDetailPipeline={setShowDetailPipeline} />
                    :
                    showDetailMeeting && settings.feature_meeting ?
                        <ChatDetailMeeting data={meeting!} setShowDetailMeeting={setShowDetailMeeting} />
                        :
                        showDetailMerchant && settings.feature_merchant ?
                            <ChatDetailMerchant data={merchant!} setShowDetailMerchant={setShowDetailMerchant} />
                            :
                            showDetailSession && settings.chat_version === 'v2' ?
                                <ChatDetailSession dataSession={sessionHistory!} setShowDetailSession={setShowDetailSession} />
                                :
                                <>
                                    <div className="card mb-5" style={{ backgroundColor: "#50cd89" }}>
                                        <h3 className="py-3 px-5 d-flex align-items-center gap-3 text-white">
                                            <i className="fas fa-times fs-3 text-hover-white cursor-pointer text-white" onClick={() => setIsOpenDetailContact(false)}></i>
                                            {intl.formatMessage({ id: "FORM.LABEL.CONTACT_DETAILS" })}
                                        </h3>
                                        <div className="card-body d-flex flex-center flex-column pt-5 px-5 pb-9">
                                            <div className='symbol symbol-45px symbol-circle'>
                                                <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                                                    <img src={toAbsoluteUrl('/media/logos/logo-wooblazz.png')} className='symbol symbol-45px symbol-circle img-fluid' style={{ padding: "10px" }} alt='profile' />
                                                </span>
                                            </div>
                                            <div className="fs-4 fw-bolder d-flex gap-2 text-white">
                                                {
                                                    recentChat && selectedChatPhone.length > 1 &&
                                                    <OverlayTrigger
                                                        key={`bullet-${recentChat.roomPhone}`}
                                                        placement='top'
                                                        overlay={
                                                            <TooltipBs id='tooltip-labels'>
                                                                <p><b>{recentChat.as}</b></p>
                                                                <span>{selectedChatPhone.find(item => item.phone === recentChat.as)?.ownersName.join(', ')}</span>
                                                            </TooltipBs>}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <span className="bullet bullet-dot h-10px w-10px" style={{ backgroundColor: recentChat.color }}></span>
                                                        </div>
                                                    </OverlayTrigger>
                                                }
                                                {name}
                                            </div>
                                            <div className="fw-bold mb-6 text-white">{phoneNumber.split('-')[0]}</div>
                                            {
                                                recentChat?.merchants.length > 0 && <i className="text-center text-white">{recentChat.merchants.map((data: ChatMerchant) => data.name).join(', ')}</i>
                                            }
                                        </div>
                                    </div>

                                    {
                                        recentChat?.labels && recentChat?.labels?.length > 0 &&
                                        <div className="card mb-5">
                                            <div className="card-body" style={{ padding: "2rem" }}>
                                                <div className="d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-3 gap-3">
                                                    Label
                                                </div>
                                                <div className="d-flex gap-4 flex-wrap justify-content-center">
                                                    {
                                                        recentChat?.labels?.map((label: any, index: number) => (
                                                            <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'wrap' }}>
                                                                <svg viewBox="0 0 24 24" height="20" width="20" className="me-2" preserveAspectRatio="xMidYMid meet" fill="none" style={{ color: label.color, width: '20px', flexShrink: 0, marginBottom: "auto" }}>
                                                                    <path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M15.393 5C16.314 5 17.167 5.447 17.685 6.182L21.812 12L21.346 12.657L17.686 17.816C17.166 18.553 16.314 19 15.393 19L5.81 18.992C4.262 18.992 3 17.738 3 16.19V7.81C3 6.261 4.262 5.008 5.809 5.008L15.393 5Z"></path>
                                                                </svg>
                                                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}>
                                                                    {label.name}
                                                                </span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        settings.feature_pipeline && user.data.permission_pipeline_read !== 'NONE' &&
                                        <div className="card mb-5">
                                            <div className="card-body" style={{ padding: "2rem" }}>
                                                <div className="d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-3 gap-3">
                                                    {settings.pipeline_title}
                                                    {
                                                        listPipeliens.length > 0 && <span className="badge badge-light-success">{listPipeliens.length}</span>
                                                    }
                                                </div>
                                                <span className="svg-icon svg-icon-1 position-absolute ms-3 mt-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <input type="search" onChange={handleSearchPipeline} value={searchPipeline} className="form-control form-control-sm form-control-solid ps-12" placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })} />
                                                {
                                                    isValidatingDataPipelines ?
                                                        <div className="loading-overlay">
                                                            <div className="loader"></div>
                                                        </div>
                                                        :
                                                        listPipeliens.length > 0 ?
                                                            <div className="mt-3" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                                                                {
                                                                    listPipeliens.map((pipeline: Pipeline, index: number) => (
                                                                        <div key={index} className="d-flex align-items-center flex-wrap flex-grow-1 mb-5 cursor-pointer text-hover-primary" onClick={() => handleClickDetailPipeline(pipeline)}>
                                                                            <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                                                <span className="fs-6 fw-bolder mb-1">{pipeline.merchant_name}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">{pipeline.owner_name}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">Database: {pipeline.lead_template_name}</span>
                                                                            </div>
                                                                            <div className="text-end py-lg-0 py-2">
                                                                                <span className="text-gray-800 fw-bolder fs-5">{pipeline.nominal}</span>
                                                                                <span className="text-gray-400 fs-7 fw-bold d-block">{pipeline.lead_age}</span>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            :
                                                            <h4 style={{ padding: "2rem", textAlign: "center" }}>
                                                                {intl.formatMessage({ id: "FORM.LABEL.DATA_NOT_FOUND" })}
                                                            </h4>
                                                }
                                            </div>
                                        </div>
                                    }

                                    {
                                        settings.feature_meeting && user.data.permission_meeting_read !== 'NONE' &&
                                        <div className="card mb-5">
                                            <div className="card-body" style={{ padding: "2rem" }}>
                                                <div className=" d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-2 gap-3">
                                                    {settings.meeting_title}
                                                    {
                                                        listMeetings.length > 0 && <span className="badge badge-light-success">{listMeetings.length}</span>
                                                    }
                                                </div>
                                                <span className="svg-icon svg-icon-1 position-absolute ms-3 mt-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <input type="search" onChange={handleSearchMeeting} value={searchMeeting} className="form-control form-control-sm form-control-solid ps-12" placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })} />
                                                {
                                                    isValidatingDataMeetings ?
                                                        <div className="loading-overlay">
                                                            <div className="loader"></div>
                                                        </div>
                                                        :
                                                        listMeetings.length > 0 ?
                                                            <div className="mt-3" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                                                                {
                                                                    listMeetings.map((meeting: Meeting, index: number) => (
                                                                        <div key={index} className="d-flex align-items-center flex-wrap flex-grow-1 mb-5 cursor-pointer text-hover-primary" onClick={() => handleClickDetailMeeting(meeting)}>
                                                                            <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                                                <span className="fs-6 fw-bolder mb-1">{meeting.owner_name} {meeting.type === 'VISIT' && <span className="badge badge-light-primary" >{intl.formatMessage({ id: 'MEETING.STATUS.VISIT' })}</span>}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">{moment(meeting.date_meet).format('DD MMMM YYYY HH:mm')}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">Database: {meeting.meetingTemplateName}</span>
                                                                            </div>
                                                                            <div className="text-end py-lg-0 py-2">
                                                                                {returnStatus(meeting)}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            :
                                                            <h4 style={{ padding: "2rem", textAlign: "center" }}>
                                                                {intl.formatMessage({ id: "FORM.LABEL.DATA_NOT_FOUND" })}
                                                            </h4>
                                                }
                                            </div>
                                        </div>
                                    }

                                    {
                                        settings.feature_merchant && user.data.permission_merchant_read !== 'NONE' &&
                                        <div className="card mb-5">
                                            <div className="card-body" style={{ padding: "2rem" }}>
                                                <div className=" d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-2 gap-3">
                                                    {settings.merchant_title}
                                                    {
                                                        listMerchants.length > 0 && <span className="badge badge-light-success">{listMerchants.length}</span>
                                                    }
                                                </div>
                                                <span className="svg-icon svg-icon-1 position-absolute ms-3 mt-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <input type="search" onChange={handleSearchMerchant} value={searchMerchant} className="form-control form-control-sm form-control-solid ps-12" placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })} />
                                                {
                                                    isValidatingDataMerchants ?
                                                        <div className="loading-overlay">
                                                            <div className="loader"></div>
                                                        </div>
                                                        :
                                                        listMerchants.length > 0 ?
                                                            <div className="mt-3" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                                                                {
                                                                    listMerchants.map((merchant: Merchant, index: number) => (
                                                                        <div key={index} className="d-flex align-items-center flex-wrap flex-grow-1 mb-5 cursor-pointer text-hover-primary" onClick={() => handleClickDetailMerchant(merchant)}>
                                                                            <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                                                <span className="fs-6 fw-bolder mb-1">{merchant.name} <span className="badge badge-light-success" >{merchant.ownerName}</span></span>
                                                                                <span className="text-gray-400 fw-bold fs-7">{merchant.phone}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">Database : {merchant.merchantTemplateName}</span>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            :
                                                            <h4 style={{ padding: "2rem", textAlign: "center" }}>
                                                                {intl.formatMessage({ id: "FORM.LABEL.DATA_NOT_FOUND" })}
                                                            </h4>
                                                }
                                            </div>
                                        </div>
                                    }

                                    {
                                        settings.chat_version === 'v2' &&
                                        <div className="card mb-5" id="history-session">
                                            <div className="card-body" style={{ padding: "2rem" }}>
                                                <div className=" d-flex align-items-center fs-4 text-gray-800 fw-bolder mb-2 gap-3 justify-content-between">
                                                    {intl.formatMessage({ id: "FORM.LABEL.SESSION_HISTORY" })}
                                                    <DateRangePicker
                                                        style={{ width: "230px" }}
                                                        cleanable={false}
                                                        character=" - "
                                                        format="dd MMM yyyy"
                                                        locale={calendarLocale}
                                                        value={[startDateSession, endDateSession]}
                                                        ranges={predefinedRanges}
                                                        placement="topEnd"
                                                        onChange={(value) => {
                                                            if (value && value.length === 2) {
                                                                setStartDateSession(value[0]);
                                                                setEndDateSession(value[1]);
                                                            }
                                                        }}
                                                        showOneCalendar={true}
                                                        disabled={isValidatingDataSessionHistories}
                                                        isoWeek={true}
                                                        editable={false}
                                                        preventOverflow={false}
                                                        container={() => document.getElementById('history-session')!}
                                                    />
                                                </div>
                                                <span className="svg-icon svg-icon-1 position-absolute ms-3 mt-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                                    </svg>
                                                </span>
                                                <input type="search" onChange={handleSearchSession} value={searchSessionHistory} className="form-control form-control-sm form-control-solid ps-12" placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })} />
                                                {
                                                    isValidatingDataSessionHistories ?
                                                        <div className="loading-overlay">
                                                            <div className="loader"></div>
                                                        </div>
                                                        :
                                                        listSessionHistories.length > 0 ?
                                                            <div className="mt-3" style={{ maxHeight: "300px", overflowY: "scroll" }}>
                                                                {
                                                                    listSessionHistories.map((session: ChatAgent, index: number) => (
                                                                        <div key={index} className="d-flex align-items-center flex-wrap flex-grow-1 mb-5 cursor-pointer text-hover-primary" onClick={() => handleClickDetailSession(session)}>
                                                                            <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3">
                                                                                <span className="fs-6 fw-bolder mb-1">{returnHandlerSession(session)}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">{intl.formatMessage({ id: "FORM.LABEL.LAST_ACTIVITY" })} : {moment(session.lastActivity.date).utc(true).format('DD MMMM YYYY HH:mm')}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">{intl.formatMessage({ id: "FORM.LABEL.DURATION" })} : {session.ended ? getDateRangeDuration(session.started.date, session.ended.date) : "-"}</span>
                                                                                <span className="text-gray-400 fw-bold fs-7">{intl.formatMessage({ id: "FORM.LABEL.AVERAGE_RESPONSE_TIME" })} : {formatSecondsToTime(session.avgReplySpeedInSeconds)}</span>
                                                                            </div>
                                                                            <div className="text-end py-lg-0 py-2">
                                                                                {
                                                                                    session.state === 'active' ?
                                                                                        <span className="badge badge-light-primary">{intl.formatMessage({ id: "FORM.LABEL.ACTIVE" })}</span>
                                                                                        : session.state === 'idle' ?
                                                                                            <span className="badge badge-light-info">Idle</span>
                                                                                            : session.state === 'waiting' ?
                                                                                                <span className="badge badge-light-warning">{intl.formatMessage({ id: "FORM.LABEL.WAITING" })}</span>
                                                                                                : session.state === 'ended' ?
                                                                                                    <span className="badge badge-light-success">{intl.formatMessage({ id: "FORM.LABEL.END" })}</span>
                                                                                                    : <></>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            :
                                                            <h4 style={{ padding: "2rem", textAlign: "center" }}>
                                                                {intl.formatMessage({ id: "FORM.LABEL.DATA_NOT_FOUND" })}
                                                            </h4>
                                                }
                                            </div>
                                        </div>
                                    }
                                </>
            }
        </div>
    );
};

export { DetailContactChat };
